import { render } from "./HighHeader.vue?vue&type=template&id=7dcb8f37&scoped=true"
import script from "./HighHeader.vue?vue&type=script&lang=js"
export * from "./HighHeader.vue?vue&type=script&lang=js"

import "./HighHeader.vue?vue&type=style&index=0&id=7dcb8f37&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dcb8f37"]])

export default __exports__